/**
 * Hydrate English language-toggle flags from the visitor country.
 * Shared by the control-panel app bundle and the login bundle.
 */
const COUNTRY_URL = '/cp/modules/account/json/visitor-country.php';
const EN_FLAG_MAP = {
	ie: 'ie',
	au: 'au',
	us: 'us',
	ca: 'ca',
	nz: 'nz',
};

/**
 * @param {string} strCountry Visitor ISO country code.
 * @return {string} flag-icons ISO for the English locale option.
 */
function englishLocaleFlagIso ( strCountry ) {
	const strKey = String( strCountry || '' ).toLowerCase();

	return EN_FLAG_MAP[ strKey ] || 'gb';
}

/**
 * Rewrite [data-en-locale-flag] elements to the country-specific fi-* class.
 *
 * @param {string} strCountry Visitor ISO country code.
 */
export function applyEnLocaleFlag ( strCountry ) {
	const strIso = englishLocaleFlagIso( strCountry );

	document.querySelectorAll( '[data-en-locale-flag]' ).forEach( ( el ) => {
		el.className = el.className
			.replace( /\bfi-[a-z]{2}\b/g, '' )
			.replace( /\s+/g, ' ' )
			.trim();
		el.classList.add( 'fi', `fi-${strIso}` );
	} );
}

/**
 * Fetch visitor country and apply the English locale flag when toggles are present.
 */
export function loadEnLocaleFlag () {
	if ( !document.querySelector( '[data-en-locale-flag]' ) ) {
		return;
	}

	fetch( COUNTRY_URL )
		.then( ( response ) => response.json() )
		.then( ( objData ) => {
			if ( objData && objData.status === 200 && objData.country ) {
				applyEnLocaleFlag( objData.country );
			}
		} )
		.catch( () => {
			// Keep the SSR default (fi-gb).
		} );
}
